/**************************************************
 * Nombre:       Home_Servicio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_servicios.png'
import foto from '../../../Recursos/foto_servicio.png'
import {NEGRITA} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Servicio = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 6, md: 4}}
                              sx={{justifyContent: !masSM ? 'center' : 'flex-start', my: -12, mt: !masSM ? -20 : -12}}>
                            <img src={foto} width={!masSM ? '90%' : '140%'} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{color: '#fff'}}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: !masSM ? 16 : 8}}>
                                    <Typography
                                        sx={{
                                            fontFamily: NEGRITA,
                                            fontSize: sCell ? 24 : 32,
                                            fontWeight: 600,
                                            lineHeight: 1.1,
                                            textAlign: sCell ? 'center' : 'left'
                                        }}>Servicio
                                        de </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: -0.5}}>
                                    <Typography
                                        sx={{
                                            fontFamily: NEGRITA,
                                            fontSize: sCell ? 56 : 64,
                                            fontWeight: 600,
                                            lineHeight: 1.1,
                                            textAlign: sCell ? 'center' : 'left'
                                        }}>
                                        Restaurante
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2, mb: !masSM ? 8 : 0}}>
                                    <Typography
                                        sx={{
                                            fontSize: 18,
                                            fontWeight: 400,
                                            lineHeight: 1.3,
                                            textAlign: sCell ? 'center' : 'left'
                                        }}>
                                        Con una larga tradición, nuestro restaurante ahora ofrece un servicio privado
                                        para huéspedes, garantizando una experiencia gastronómica exclusiva, con
                                        excelente atención y total privacidad.
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Servicio


